import styled from "styled-components";

export const Container = styled.div`
  color: rgb(102, 102, 102);
  line-height: 1.1;
  font-size: 20px;
  text-transform: capitalize;
`;
